import { useCallback, useContext, useState } from "react";
import { SitesAndActivityContext } from "./sitesAndActivityContext";

export function SitesAndActivityProvider({children}){
    const [calculatorInfo, setCalculatorInfo] = useState({
        id: null,
        sites: [],
        activities: [],
        kids: 0,
        adults: 0,
        name: null
    });

    const [sharedData, setSharedData] = useState(null);

    const [editSitesAndActivityData, setEditSitesAndActivityData] = useState(null);

    const updateName = useCallback((name) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            name: name
        }));
    }, []);

    const updateFiltersData = useCallback((sites, activities, kids, adults, id) => {
        setCalculatorInfo((prevObj) => ({
            ...prevObj,
            id: id,
            sites: sites,
            activities: activities,
            kids: kids,
            adults: adults
        }));
    }, []);

    const clearCalculator = useCallback(() => {
        setCalculatorInfo({
            id: null,
            sites: [],
            activities: [],
            kids: 0,
            adults: 0,
            name: null
        });
    }, []);

    const updateSharedData = useCallback((response) => {
        setSharedData(response);
    }, []);

    const editSitesAndActivity = useCallback((summaryData) => {
        setEditSitesAndActivityData(summaryData);
    }, []);

    const clearEditSitesAndActivityHistory = useCallback(() => {
        setEditSitesAndActivityData(null);
    }, []);

    const value = {
        calculatorInfo,
        updateFiltersData,
        clearCalculator,
        updateName,

        sharedData,
        updateSharedData,

        editSitesAndActivityData,
        editSitesAndActivity,
        clearEditSitesAndActivityHistory
    }

    return (
        <SitesAndActivityContext.Provider value={value}>
            {children}
        </SitesAndActivityContext.Provider>
    );
}

export const GetSitesAndActivityInfo = () => {
    return useContext(SitesAndActivityContext);
};